import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import ResetPass from '../views/ResetPass.vue'
import IntendCollect from '../views/IntendCollect.vue'
import CollectEnd from '../views/CollectEnd.vue'
import NoHealingEffects from '../views/NoHealingEffects.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import UserAgreement from '../views/UserAgreement.vue'
import ContrastCreate from '../views/ContrastCreate.vue'
import SetPass from '../views/SetPass.vue'


import {
  checkIp
} from "@/api/index";

Vue.use(VueRouter)

// 重写 push 方法
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

// 重写 replace 方法
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/Register', // 账号注册
    name: 'Register',
    component: Register,
  },
  {
    path: '/SetPass', // 设置密码
    name: 'SetPass',
    component: SetPass,
    meta: {
      requiresAuth: true
    } // 标记：需要登录才能访问
  },
  {
    path: '/IntendCollect', // 准备采集
    name: 'IntendCollect',
    component: IntendCollect,
    meta: {
      requiresAuth: true
    } // 标记：需要登录才能访问
  },
  {
    path: '/PrivacyPolicy', // 隐私政策
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/UserAgreement', // 用户协议
    name: 'UserAgreement',
    component: UserAgreement
  },
  {
    path: '/CollectEnd', // 第一次疗愈结束
    name: 'CollectEnd',
    component: CollectEnd,
    meta: {
      requiresAuth: true
    } // 标记：需要登录才能访问
  },
  {
    path: '/ContrastCreate', // 疗愈对比，第二次报告
    name: 'ContrastCreate',
    component: ContrastCreate,
    meta: {
      requiresAuth: true
    } // 标记：需要登录才能访问
  },
  {
    path: '/NoHealingEffects', // 第一次报告
    name: 'NoHealingEffects',
    component: NoHealingEffects,
    meta: {
      requiresAuth: true
    } // 标记：需要登录才能访问
  },
  {
    path: '/ResetPass', // 重置密码
    name: 'ResetPass',
    component: ResetPass,
  },
  // ✨ 新增：匹配所有不存在的路径，重定向到首页（必须放在最后！）
  {
    path: '*',
    redirect: '/'
  }
]


const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  // ✨ 核心配置：路由跳转时滚动到顶部
  scrollBehavior(to, from, savedPosition) {
    // 1. 基础版：所有跳转都回到顶部
    return {
      x: 0,
      y: 0
    }

    // 2. 进阶版（可选）：返回时恢复滚动位置，跳转新页面才到顶部
    // if (savedPosition) {
    //   return savedPosition // 浏览器后退/前进时恢复位置
    // } else {
    //   return { x: 0, y: 0 } // 新跳转时回到顶部
    // }
  }
})

// ✅ 辅助函数：检测是否为页面刷新
function isPageRefresh() {
  try {
    // Chrome/Edge/Firefox 新 API
    const nav = performance.getEntriesByType('navigation')[0]
    if (nav?.type === 'reload') return true
    
    // 旧 API 兼容
    if (performance.navigation?.type === 1) return true
  } catch (e) {}
  return false
}

// 标记是否已调用过IP接口（避免重复调用）
let hasFetchedIP = false
let inChina = true
// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  // 仅在首次进入项目时调用查询IP（刷新/首次打开/从外部进入）
  if (!hasFetchedIP) {
    try {
      await checkIp().then((res) => {
        localStorage.setItem('inChina', JSON.stringify(res.inChina))
        inChina = res.inChina
      })
      hasFetchedIP = true // 标记为已调用，避免重复请求
    } catch (error) {
      console.error('IP接口调用失败：', error)
      // 即使失败也放行路由，不阻塞项目运行
      hasFetchedIP = true
    }
  }
  // 确认不在中国 → 强制跳首页
  if (inChina === false) {
    // 避免死循环：如果目标已是首页，直接放行
    if (to.path === '/') {
      return next()
    }
    // 可选：提示用户
    // Vue.prototype.$toast?.error?.('本服务仅限中国大陆地区使用')
    return next('/')
  }
  // ===================== 1. 修复核心bug + 基础配置 =====================
  const token = localStorage.getItem('token')
  const isLogin = !!token // 已登录：true，未登录：false

  const CONFIG = {
    // 无需登录的白名单路由
    WHITE_LIST: ['/', '/Login', '/Register', '/PrivacyPolicy', '/UserAgreement', '/ResetPass'],
    // 需要登录但未登录时跳首页的路由
    LOGIN_REQUIRED_ROUTES: ['/SetPass', '/IntendCollect', '/CollectEnd', '/ContrastCreate', '/NoHealingEffects'],
    // 路由跳转链路规则（key: 目标路由，value: 允许的来源路由数组）
    ROUTE_LINK_RULES: {
      '/IntendCollect': ['/', '/CollectEnd', '/NoHealingEffects', '/ContrastCreate'],
      '/CollectEnd': ['/IntendCollect'],
      '/ContrastCreate': ['/IntendCollect'],
      '/NoHealingEffects': ['/CollectEnd']
    }
  }

  // ===================== 2. 白名单路由逻辑（优先级最高） =====================
  if (CONFIG.WHITE_LIST.includes(to.path)) {
    // 已登录用户访问登录/注册/重置密码页 → 跳首页
    if (isLogin && ['/Login', '/Register', '/ResetPass'].includes(to.path)) {
      return next('/')
    }
    return next() // 白名单其他路由直接放行
  }

  // ===================== 3. 未登录拦截（统一处理） =====================
  if (!isLogin && CONFIG.LOGIN_REQUIRED_ROUTES.includes(to.path)) {
    return next('/')
  }

  // ===================== 4. 路由跳转链路校验（统一规则） =====================
  const allowFromRoutes = CONFIG.ROUTE_LINK_RULES[to.path]
  // 如果当前路由有链路规则，且来源路由不在允许列表中 → 跳首页
  // console.log(11111, from.path , to.path)
  if (allowFromRoutes) {
    // ✅ 检测是否为页面刷新
    const isRefresh = isPageRefresh()
    
    // ✅ 如果是刷新，跳过链路校验，直接放行
    // ✅ 如果不是刷新（首次直接访问/正常跳转），执行链路校验
    if (!isRefresh && !allowFromRoutes.includes(from.path)) {
      return next('/')
    }
  }

  // ===================== 5. 剩余权限校验（兜底） =====================
  if (to.meta?.requiresAuth && !isLogin) {
    return next('/Login')
  }

  // 所有校验通过，放行
  return next()
})

export default router